<template>
  <b-row class="identifier-mapping">
    <h2 class="v2">{{this.$t('updater.step2')}}</h2>
    <b-col>
      <b-form-group label="Was soll als Identifier dienen?" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          id="radio-group-1"
          v-model="selectedOption"
          :aria-describedby="ariaDescribedby"
          name="flavour-1"
          @change="selectIdentifierOption()"
          >
          <b-form-radio value="Standard">Standard (Weingut & Weinname & Jahrgang & Flaschengröße)</b-form-radio>
          <b-form-radio value="Artikelnummer">Artikelnummer</b-form-radio>
          <b-form-radio value="Kassennotiz">Kassennotiz</b-form-radio>
          <b-form-radio value="AI">AI</b-form-radio>
          <b-form-radio value="Import">Import</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-row v-if="wineSupplierNotFound.length > 0">
        <b-col>
          <h4>{{ this.$t('updater.wineSupplierNotFound') }}</h4>
          {{ wineSupplierNotFound.join(', ') }}
        </b-col>
      </b-row>

      <b-button @click="selectOtherIdentifier()" variant="secondary" class="mt-3 mb-3" >anderen Identifier wählen</b-button>
      <b-form-group v-if="selectedOption=='andere'" label="Was soll als Identifier dienen?" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-group-2"
          v-model="selectedIdentifier"
          :aria-describedby="ariaDescribedby"
          name="flavour-2"
        >
          <b-form-checkbox v-for="column in possibleIdentifier" :value="column.key" :key="column.key" @change="changedValue(column.key)" style="display: flex; align-items: center;">
            {{ column.value }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group label="" >
          <b-form-checkbox class="bg-green" v-model="useInnerSearch" style="display: flex; align-items: center;">
                <span class="ml-xs">{{ $t('updater.useSearchToFindWines') }}</span>
          </b-form-checkbox>
      </b-form-group>
      <b-row class="mt-3 mb-3 mapping" v-if="notFoundIdentifier.length > 0">
        <b-col>
          <h4>Nicht gefundene Identifier zuordnen:</h4>
          <b-row v-for="(column, index) in notFoundIdentifier" :key="column" :style="(index > 0 ? 'margin-top: 5px;' : '') + (index%2 == 0 ? 'background-color: #222325;' : '')">
            <b-col style="display: flex; align-items: center; margin-left: 3px;width: 100px;">
              {{ columnNameFromValue(column) }}
            </b-col>
            <b-col style="display: flex; justify-content: center;">
              <img class="arrow-icon" src="../../assets/img/icon-dropdown.svg">
            </b-col>
            <b-col>
              <b-form-select class="v2 green" v-model="rowMappingObject[column]" :options="csvColumns" @change="triggerReload = !triggerReload">
                <template #first>
                  <b-form-select-option value="" disabled>{{ $t('general.dropdownText') }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-alert class="updater" :show="true">
        Ausgewählte Identifier: {{ Object.keys( rowMappingObject).map((key) => { return "Spalte " + rowMappingObject[key] + " als "+ columnNameFromValue(key)}).join(', ') }}
        </b-alert>
      </b-row>
    </b-col>
    <ButtonFooter :backButtonVisible="true" :okButtonDisabled="buttonDisabled"
           :backButtonLabel="this.$t('general.buttons.back')" :okButtonLabel="this.$t('general.buttons.forward')" :okAction="() => finishedMapping(rowMappingObject, selectedOption, useInnerSearch)" :backAction="handleBackFromStep2"/>
  </b-row>

</template>
<script>
import ButtonFooter from '@/components/modals/ButtonFooter.vue'
import constants from '../../utils/constants';

export default {
  name: "TargetMapping",
  components: {
    ButtonFooter
  },
  props: {
    csvColumns: Array,
    finishedMapping: Function,
    identifierMappingObject: Object,
    preSelectedOption: String,
    wineSupplierNotFound: Array,
    useSearch: Boolean
  },
  data() {
    return {
      selectedOption: 'Standard',
      selectedIdentifier: [],
      possibleIdentifier: [{
        key: 'articleNumber', value: 'Artikelnummer'},
        {key: 'producer', value: 'PQ:Hersteller'},
        {key: 'articleName', value: 'PQ:Artikelname'},
        {key: 'pdfArticleName', value: 'KI:Artikelname'},
        {key: 'pdfProducerName', value: 'KI:Hersteller'},
        {key: 'year', value: 'Jahrgang'},
        {key: 'region', value: 'Region'},
        {key: 'land', value: 'Land'},
        {key: 'wineType', value: 'Farbe'},
        {key: 'grapeVariety', value: 'Rebsorte'},
        {key: 'bottleSize', value: 'Flaschengröße'},
        {key: 'comment', value: 'Kommentar'},
        {key: 'pqVenueWineId', value: 'PQ:VenueWine ID'},
        {key: 'pqWineId', value: 'PQ:Wine ID'},
        {key: 'category', value: 'Kategorie'},
        {key: 'purchasePrice', value: 'Preis'},
        {key: 'purchaseDate', value: 'Wareneingang'},
        {key: 'vendorArticleNumber', value: 'Lieferanten Artikelnummer'},
        {key: 'vendorArticleName', value: 'Lieferanten Artikelname'}
      ],
      notFoundIdentifier: [],
      rowMappingObject: {},
      triggerReload: false,
      useInnerSearch: true,
    }
  },
  created() {
    this.useInnerSearch = this.useSearch;
    this.rowMappingObject = this.identifierMappingObject;
    this.selectedOption = this.preSelectedOption;
    // only on first time use: select an option and use the selected keys as values in rowMappingObject
    if (Object.keys(this.identifierMappingObject).length === 0) {
      this.selectIdentifierBasedOnSelectedOption();
      this.useKeyAsValueForMapping();
    }
    this.addValuesFromMappingObject()
    this.checkIfCsvColumnsContainIdentifierAndPush();
  },
  methods: {
    handleBackFromStep2() {
      this.$emit('backFromStep2');
    },
    selectIdentifierOption() {
      this.selectIdentifierBasedOnSelectedOption();
      this.useKeyAsValueForMapping();
      this.notFoundIdentifier = [];
      this.checkIfCsvColumnsContainIdentifierAndPush();
    },
    selectIdentifierBasedOnSelectedOption(){
      if (this.selectedOption == 'Standard') {
        this.selectedIdentifier = [ 'producer',
          'articleName',
          'year',
          'bottleSize'];
      } else if (this.selectedOption == 'Artikelnummer') {
        this.selectedIdentifier = [ 'articleNumber'];
      } else if (this.selectedOption == 'Kassennotiz') {
        this.selectedIdentifier = [ 'cashNote'];
      } else if (this.selectedOption == 'AI') {
        this.selectedIdentifier = ['purchaseDate','category','producer',
          'articleName','grapeVariety','wineType', 'year', 'bottleSize',
          'region', 'land',  
          'articleNumber', 'pqVenueWineId', 'pqWineId'];
      } else if (this.selectedOption == 'Import') {
        this.selectedIdentifier = ['producer','articleName','year','bottleSize','category','grapeVariety','wineType','region','land'];
      } else {
        this.selectedIdentifier = [];
      }
      var predefinedKeys = constants.UPDATER_IDENTIFIER_MAPPING
      this.rowMappingObject = {}
      for (let key of this.selectedIdentifier) {
        if (this.csvColumns.includes(predefinedKeys[key])) {
          this.rowMappingObject[key] = predefinedKeys[key];
        } else {
          this.rowMappingObject[key] = '';
        }
      }
    },
    selectOtherIdentifier() {
      this.selectedOption = 'andere';
      this.selectedIdentifier = [];
      this.notFoundIdentifier = [];
      this.rowMappingObject = {}
      this.useKeyAsValueForMapping();
    },
    checkIfCsvColumnsContainIdentifierAndPush() {
      for (let identifier of this.selectedIdentifier) {
        const value = this.columnNameFromValue(identifier);
        if (!this.csvColumns.includes(value) && this.csvColumns.includes(constants.UPDATER_IDENTIFIER_MAPPING[identifier]) == false && this.notFoundIdentifier.indexOf(identifier) == -1) {
          this.notFoundIdentifier.push(identifier);
        }
      }
    },
    useKeyAsValueForMapping() {
      // this.rowMappingObject = {}

      for (let key of this.selectedIdentifier) {
        const value = this.columnNameFromValue(key);
        if (this.csvColumns.includes(value)) {
          this.rowMappingObject[key] = value;
        } else {
          if (constants.UPDATER_IDENTIFIER_MAPPING[key] && this.csvColumns.includes(constants.UPDATER_IDENTIFIER_MAPPING[key])) {
            this.rowMappingObject[key] = constants.UPDATER_IDENTIFIER_MAPPING[key];
          } else {  
            this.rowMappingObject[key] =  this.rowMappingObject[key] || '';
          }
        }
      }
    },
    changedValue(value) {
      this.$nextTick(() => {
        // was added now:
        console.log(this.selectedIdentifier, 'selectedIdentifier after changedValue')
        if (this.selectedIdentifier.indexOf(value) > -1) {
          console.log('added', value)
          if (this.csvColumns.indexOf(value) == -1){
            this.rowMappingObject[value] = '';
          } else {
            this.rowMappingObject[value] = value;
          }
        } else {
          console.log('removed', value)
          this.notFoundIdentifier = this.notFoundIdentifier.filter((item) => item != value);
          delete this.rowMappingObject[value];
        }
        this.triggerReload = !this.triggerReload;
        this.useKeyAsValueForMapping();
        this.checkIfCsvColumnsContainIdentifierAndPush();
       
      })
    },
    addValuesFromMappingObject(){
      var keys = Object.keys(this.rowMappingObject)
      for (var i = 0; i < keys.length; i++) {
        if (this.rowMappingObject[keys[i]] != null && this.rowMappingObject[keys[i]] != undefined && this.rowMappingObject[keys[i]] != '') {
          this.selectedIdentifier.push(keys[i]);
        }
      }
    },
    columnNameFromValue(value) {
      
      var found = this.possibleIdentifier.find((item) => item.key == value);
      return found ? found.value : value == 'supplier' ? 'Bezugsquelle' : value;
      
    }
  },
  computed: {

    buttonDisabled() {
      this.triggerReload 
      var keys = Object.keys(this.rowMappingObject)
      console.log(this.rowMappingObject, 'rowMappingObject in buttonDisabled')
      for (var i = 0; i < keys.length; i++) {
        if (this.rowMappingObject[keys[i]] == null || this.rowMappingObject[keys[i]] == undefined || this.rowMappingObject[keys[i]] === '') {
          return true;
        }
      }
      return this.selectedIdentifier.length == 0;
    }
  },
  watch: {
    /*
    identifierMappingObject: {
      handler: function (val) {
        console.log(val, 'identifierMappingObject')
        this.rowMappingObject = val;
        this.addValuesFromMappingObject()
      },
      deep: true
    },
    preSelectedOption: {
      handler: function (val) {
        console.log(val, 'preSelectedOption')
        this.selectedOption = val;
      },
      deep: true
    }*/
  }
}
</script>